import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <strong>Arthanova Global</strong>
          <p>
            India-based technology company delivering software, AI and digital product solutions.
          </p>
        </div>

        <div className="footer-links">
          <a href="#services">Services</a>
          <a href="#delivery">Delivery</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Arthanova Global Private Limited. All
          rights reserved.
        </p>
      </div>
    </footer>
  );
}